var map = {
	"./": 320,
	"./Content": 976,
	"./Content/": 976,
	"./Content/AllSportsGrid": 977,
	"./Content/AllSportsGrid.js": 977,
	"./Content/Announcement": 953,
	"./Content/Announcement/": 953,
	"./Content/Announcement/Announcement.dictionary": 896,
	"./Content/Announcement/Announcement.dictionary.json": 896,
	"./Content/Announcement/Announcement.module.scss": 978,
	"./Content/Announcement/components/AnnouncementItem": 1046,
	"./Content/Announcement/components/AnnouncementItem.tsx": 1046,
	"./Content/Announcement/components/AnnouncementTable": 1110,
	"./Content/Announcement/components/AnnouncementTable.tsx": 1110,
	"./Content/Announcement/components/FilterByTime": 1111,
	"./Content/Announcement/components/FilterByTime.tsx": 1111,
	"./Content/Announcement/get-time-to-fetch-utils": 1112,
	"./Content/Announcement/get-time-to-fetch-utils.ts": 1112,
	"./Content/Announcement/index": 953,
	"./Content/Announcement/index.tsx": 953,
	"./Content/Announcement/types": 895,
	"./Content/Announcement/types.ts": 895,
	"./Content/Announcement/utils/get-announcements-and-options-utils": 1067,
	"./Content/Announcement/utils/get-announcements-and-options-utils.spec": 1147,
	"./Content/Announcement/utils/get-announcements-and-options-utils.spec.js": 1147,
	"./Content/Announcement/utils/get-announcements-and-options-utils.ts": 1067,
	"./Content/Announcement/utils/get-breadcrumbs-by-match-utils": 1045,
	"./Content/Announcement/utils/get-breadcrumbs-by-match-utils.ts": 1045,
	"./Content/MatchCenter": 897,
	"./Content/MatchCenter/": 897,
	"./Content/MatchCenter/MatchCenter.module.scss": 979,
	"./Content/MatchCenter/index": 897,
	"./Content/MatchCenter/index.tsx": 897,
	"./Content/SportGrid": 898,
	"./Content/SportGrid/": 898,
	"./Content/SportGrid/SportGrid.module.scss": 980,
	"./Content/SportGrid/TournamentTable": 931,
	"./Content/SportGrid/TournamentTable.js": 931,
	"./Content/SportGrid/index": 898,
	"./Content/SportGrid/index.jsx": 898,
	"./Content/StageGrid": 899,
	"./Content/StageGrid/": 899,
	"./Content/StageGrid/StageGrid": 877,
	"./Content/StageGrid/StageGrid.module.scss": 932,
	"./Content/StageGrid/StageGrid.tsx": 877,
	"./Content/StageGrid/index": 899,
	"./Content/StageGrid/index.ts": 899,
	"./Content/components/GridHeader": 863,
	"./Content/components/GridHeader.tsx": 863,
	"./Content/components/SportsGrid": 929,
	"./Content/components/SportsGrid.module.scss": 930,
	"./Content/components/SportsGrid.tsx": 929,
	"./Content/components/TournamentTable": 894,
	"./Content/components/TournamentTable.js": 894,
	"./Content/index": 976,
	"./Content/index.tsx": 976,
	"./Live": 1148,
	"./Live.dictionary": 344,
	"./Live.dictionary.json": 344,
	"./Live.explanation": 1149,
	"./Live.explanation.ts": 1149,
	"./Live.tsx": 1148,
	"./LiveDeferred": 375,
	"./LiveDeferred.tsx": 375,
	"./actions": 126,
	"./actions/": 126,
	"./actions/index": 126,
	"./actions/index.js": 126,
	"./actions/liveHub": 116,
	"./actions/liveHub.ts": 116,
	"./constants": 1106,
	"./constants.ts": 1106,
	"./index": 320,
	"./index.tsx": 320,
	"./reducer": 298,
	"./reducer/": 298,
	"./reducer/entities": 356,
	"./reducer/entities.ts": 356,
	"./reducer/index": 298,
	"./reducer/index.js": 298,
	"./reducer/presentation": 357,
	"./reducer/presentation.js": 357,
	"./selectors/entities": 155,
	"./selectors/entities.ts": 155,
	"./selectors/gridPresentation": 832,
	"./selectors/gridPresentation.ts": 832
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	if(!__webpack_require__.m[id]) {
		var e = new Error("Module '" + req + "' ('" + id + "') is not available (weak dependency)");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
webpackContext.id = 1275;
module.exports = webpackContext;